import { createElement, type ReactNode } from 'react';

import type { AnnotationSvgNode } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

const toReactAttributeName = (name: string) =>
  name.replace(/-([a-z])/g, (_match, letter: string) => letter.toUpperCase());

const renderAnnotationSvgNode = (
  node: AnnotationSvgNode,
  index: number,
): ReactNode =>
  createElement(
    node.tag,
    {
      ...Object.fromEntries(
        Object.entries(node.attributes).map(([name, value]) => [
          toReactAttributeName(name),
          value,
        ]),
      ),
      key: index,
    },
    node.text ?? node.children?.map(renderAnnotationSvgNode),
  );

export const renderAnnotationSvgNodes = (nodes: AnnotationSvgNode[]) =>
  nodes.map(renderAnnotationSvgNode);
